import { render, staticRenderFns } from "./WorkflowGraph.vue?vue&type=template&id=6510bbc4&scoped=true"
import script from "./WorkflowGraph.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowGraph.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowGraph.vue?vue&type=style&index=0&id=6510bbc4&prod&scoped=true&land=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6510bbc4",
  null
  
)

export default component.exports